export class ZoomToAreaParameters {
  function: string;
  easting1: number;
  northing1: number;
  easting2: number;
  northing2: number;
  valid: boolean;
  workspace?: string;
}
